class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      FacetFiltersForm.currentRequestUrl = url;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error("Unable to load filters");
        return response.text();
      })
      .then((responseText) => {
        if (url !== FacetFiltersForm.currentRequestUrl) return;
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      })
      .catch(() => {
        if (url === FacetFiltersForm.currentRequestUrl) {
          window.location.assign(`${window.location.pathname}?${FacetFiltersForm.searchParamsPrev}`);
        }
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const source = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const count = source ? source.innerHTML : '';
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container && source) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop && source) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting', 'mh-quick-filters'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector) || !document.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    const drawer = document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer');
    if (drawer) drawer.bindEvents();
    const quickFilters = document.querySelector('mh-quick-filters');
    if (quickFilters) quickFilters.removeAttribute('aria-busy');
    if (FacetFiltersForm.quickFocusId) {
      document.getElementById(FacetFiltersForm.quickFocusId)?.querySelector('summary')?.focus({ preventScroll: true });
      FacetFiltersForm.quickFocusId = null;
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    // Keep URL state so quick shortcuts, drawer filters, sorting and history agree.
    const params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.delete('section_id');
    if (form.id === 'FacetFiltersFormMobile') {
      [...params.keys()].filter((name) => name.startsWith('filter.')).forEach((name) => params.delete(name));
    }
    const names = new Set(Array.from(form.elements).map((element) => element.name).filter(Boolean));
    names.forEach((name) => params.delete(name));
    for (const [name, value] of new FormData(form)) {
      if (value !== '') params.append(name, value);
    }
    return params.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const form = event.target.closest('form');
    if (form) this.onSubmitForm(this.createSearchParams(form), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

let closeFacets = document.querySelector('.mobile-facets__header-inner svg');

if (closeFacets) {
  closeFacets.addEventListener("click", function (e) {
    document.querySelector('.mobile-facets__disclosure.disclosure-has-popup').removeAttribute('open')
  });
}

const accordionBtns = document.querySelectorAll(".accordion");

accordionBtns.forEach((accordion) => {
  accordion.onclick = function () {
    let content = this.nextElementSibling;

    if (this.classList.contains("is-open")) {
      content.style.maxHeight = '0';
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }

    this.classList.toggle("is-open");
  };
});

// Delegation keeps drawer groups interactive after a filter refresh.
document.addEventListener('click', (event) => {
  const summary = event.target.closest('.mobile-facets__summary');
  if (summary && summary.nextElementSibling) {
    summary.nextElementSibling.classList.toggle('mobile-facets__summary--hide');
    summary.classList.toggle('mobile-facets__summary--active');
  }
  const quickDetails = event.target.closest('.mh-quick-filter, mh-sort-menu details');
  document.querySelectorAll('.mh-quick-filter[open], mh-sort-menu details[open]').forEach((details) => {
    if (details !== quickDetails) details.open = false;
  });
});

class MHQuickFilters extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      const link = event.target.closest('a[data-quick-filter]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
      event.preventDefault();
      if (this.getAttribute('aria-busy') === 'true') return;
      const details = link.closest('details');
      FacetFiltersForm.quickFocusId = details.id;
      details.open = false;
      this.setAttribute('aria-busy', 'true');
      FacetFiltersForm.renderPage(new URL(link.href).search.slice(1));
    });
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        const details = event.target.closest('details');
        if (details) { details.open = false; details.querySelector('summary').focus(); }
      }
      if (event.key === ' ' && event.target.matches('a[data-quick-filter][role="button"]')) {
        event.preventDefault();
        event.target.click();
      }
    });
  }
}
customElements.define('mh-quick-filters', MHQuickFilters);


class MHSortMenu extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      const option = event.target.closest('[data-sort-value]');
      if (!option || !this.select) return;
      this.details.open = false;
      this.summary.focus({ preventScroll: true });
      if (this.select.value === option.dataset.sortValue) return;
      this.select.value = option.dataset.sortValue;
      this.querySelector('[data-sort-label]').textContent = option.querySelector('span').textContent;
      this.options.forEach((button) => button.setAttribute('aria-pressed', String(button === option)));
      FacetFiltersForm.quickFocusId = this.details.id;
      this.select.dispatchEvent(new Event('input', { bubbles: true }));
    });
    this.addEventListener('keydown', (event) => {
      if (!this.details) return;
      if (event.key === 'Escape' && this.details.open) {
        event.preventDefault();
        event.stopPropagation();
        this.details.open = false;
        this.summary.focus({ preventScroll: true });
        return;
      }
      const keys = ['ArrowDown', 'ArrowUp', 'Home', 'End'];
      if (!keys.includes(event.key)) return;
      event.preventDefault();
      const index = this.options.indexOf(event.target.closest('[data-sort-value]'));
      let next = index;
      if (!this.details.open || index < 0) {
        this.details.open = true;
        next = this.options.findIndex((option) => option.dataset.sortValue === this.select.value);
      } else if (event.key === 'ArrowDown') next = (index + 1) % this.options.length;
      else if (event.key === 'ArrowUp') next = (index - 1 + this.options.length) % this.options.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = this.options.length - 1;
      this.options[Math.max(0, next)]?.focus();
    });
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget) && this.details) this.details.open = false;
    });
  }

  connectedCallback() {
    this.select = this.querySelector('select[name="sort_by"]');
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.options = Array.from(this.querySelectorAll('[data-sort-value]'));
    if (!this.select || !this.details || !this.summary || !this.options.length) return;
    this.select.closest('.select').hidden = true;
    this.details.hidden = false;
  }
}
customElements.define('mh-sort-menu', MHSortMenu);

